import { Component, Input, ElementRef, SimpleChanges, OnDestroy, Output, EventEmitter, OnInit } from '@angular/core';
import moment from 'moment';

import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { TimeOffService } from 'src/app/pages/timeoff/time-off.service';

import { OrderByPipe } from '../../pipe/order-by.pipe';

@Component({
  selector: 'datatable',
  templateUrl: './webix-datatable.component.html',
})
export class WebixDatatablecomponent implements OnInit, OnDestroy {
  private ui: webix.ui.datatable;
  data: any[] = [];
  @Input() formData: any;
  @Input() company: any;
  @Input() userKeyID: number;
  @Output() selectedData = new EventEmitter<any[]>();
  @Output() alert = new EventEmitter<any>();
  @Output() loadingStatus =  new EventEmitter<any>();
  webixDataList: any[];
  portalSettings: any;
  monthOn: boolean;
  userData: any;
  monthChangeTrigger: boolean;
  orderByPipe: OrderByPipe;
  newDateArray: any;
  monthData: any;
  msg: any;
  xaxis: number;
  yaxis: number;

  constructor(private root: ElementRef, private portalSettingsService: PortalSettingsService, private timeOffService: TimeOffService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit() {
    this.orderByPipe = new OrderByPipe();
    if(this.ui != null)
      this.ui.resize();
  }

  ngOnDestroy() {
    if (this.ui) {
      this.ui.destructor();
    }
  }

  loadGrid(){
    if(this.monthData != null && this.monthData.length > 0 && this.newDateArray != null && this.newDateArray.length > 0 ){
      this.ui = <webix.ui.datatable>webix.ui({
        container: "timeoffGrid",
        id: "timeoffGrid",
        view: "datatable",
        columns: this.newDateArray,
        data: this.monthData,
        autoheight: true,
        leftSplit: 1,
        onClick: {
          "load": (event, id) => {
            setTimeout(() => {
              var temp = this.ui.getItem(id.row);
              var data = temp[id.column].split("|")
              this.data = [];
              for (var i = 1; i < data.length; i++) {
                this.data[data[i]] = data[i + 1];
                i++;
              }
              this.selectedData.emit(this.data);
              this.xaxis = event.x - 200;
              this.yaxis = event.y - 250;
              var msg = {};
              setTimeout( () => {
                msg = {
                  type: (this.data["Status"] == "Approved") ? "success" : (this.data["Status"] == "Rejected") ? "danger" : (this.data["Status"] == "H") ? "info" : "warning",
                  msg: "Leave Code: " + this.data["LeaveCode"] + "\n\nFrom: " + this.data["FromDate"] + "\n\nTo: " + this.data["ToDate"] + "\n\nTotal Hours: " + this.data["Hours"],
                  xaxis: this.xaxis,
                  yaxis: this.yaxis
                };
                this.alert.emit(msg);
              });
            });
          }
        }
      });
      this.ui.refresh();
      this.ui.resize();
    }
    this.loadingStatus.emit(true);
  }
  
  webixUpdate(webixGridData: any) {
    this.webixDataList = [];
    webixGridData.forEach((val: any, key: any) => {
      var tf = false;
      if (this.webixDataList.length == 0 && val.SubmittedbyFullName != "Holiday") {
        this.webixDataList.push({ id: key, Employee: val.SubmittedbyFullName, PREHKeyID: val.PREHKeyID });
      }
      this.webixDataList.forEach((val2: any, key2: any) => {
        if (val2.PREHKeyID == val.PREHKeyID) {
          tf = true;
        }
        if (key2 == this.webixDataList.length - 1 && !tf && val.SubmittedbyFullName != "Holiday") {
          this.webixDataList.push({ id: key, Employee: val.SubmittedbyFullName, PREHKeyID: val.PREHKeyID });
        }
      });
    });
    webixGridData.forEach(val => {
      this.webixDataList.forEach(val2 => {
        if (val2.PREHKeyID == val.PREHKeyID) {
          if (this.portalSettings["CountryDateCode"].ConfigValue == "US")
            var tempAdd = new Date(parseInt("20" + val.FromDateDisplay.substring(6, 8)), parseInt(val.FromDateDisplay.substring(0, 2)) - 1, val.FromDateDisplay.substring(3, 5));
          else {
            var tempAdd = new Date(parseInt("20" + val.FromDateDisplay.substring(6, 8)), parseInt(val.FromDateDisplay.substring(3, 5)) - 1, val.FromDateDisplay.substring(0, 2));
          }
          val2[tempAdd.getMonth() + 1] = true;
          val2["editor"] = "LeaveCode: " + (val.LeaveDescription == null ? "" : val.LeaveDescription) + " FromDate: " + val.FromDateDisplay + " ToDate: " + val.ToDateDisplay + " Hours: " + val.PlannedHours;
          while (tempAdd <= (this.portalSettings["CountryDateCode"].ConfigValue == "US" ? new Date(parseInt("20" + val.ToDateDisplay.substring(6, 8)), parseInt(val.ToDateDisplay.substring(0, 2)) - 1, val.ToDateDisplay.substring(3, 5)) : new Date(parseInt("20" + val.ToDateDisplay.substring(6, 8)), parseInt(val.ToDateDisplay.substring(3, 5)) - 1, val.ToDateDisplay.substring(0, 2)))) {
            var month = tempAdd.getMonth() + 1;
            var date = tempAdd.getDate().toString().length == 1 ? "0" + tempAdd.getDate() : tempAdd.getDate();
            var year = this.formData.selectedMonth.getFullYear();
            var dateKey = month + "/" + date + "/" + year;
            if (!val2.hasOwnProperty(dateKey) ||
              (val2.hasOwnProperty(dateKey) &&
                ((val2[dateKey].substring(0, 1) != "A" && val.RequestStatus == "Approved") ||
                  (val2[dateKey].substring(0, 1) == "R" && val.RequestStatus == "Pending")))) {
              val2[dateKey] =
                (val.RequestStatus == "H" ? "H<a style='background-color:#00c4ff;color:white;font-size: 28px;margin-left:-24px;padding: 7px;' href='javascript:void(0)' class='load'><i class='modus-icons'>car_front</i></a>" :
                  val.RequestStatus == "Approved" ? (val.PlannedHours >= val.DefaultWorkHours ? "A<a style='background-color:#5cb85c;color:white;font-size: 27px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>circle_check_outline</i></a>" : "A<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/approvedHalf.png'/></a>") :
                    val.RequestStatus == "Rejected" ? (val.PlannedHours >= val.DefaultWorkHours ? "R<a style='background-color:red;color:white;font-size: 26px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>cancel_circle</i></a>" : "R<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/rejectedHalf.png'/></a>") :
                      val.RequestStatus == "Pending" ? (val.PlannedHours >= val.DefaultWorkHours ? "P<a style='background-color:#ECC816;color:white;font-size: 29px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>help</i></a>" : "P<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/pendingHalf.png'/></a>") :
                        (tempAdd.getDay() != 0 && tempAdd.getDay() != 6 ? "C<a style='background-color:white;color:white;font-size:20px;margin-left:-24px;padding:20px;'></a>" : "C<a style='background-color:rgb(204, 204, 204);color:rgb(204, 204, 204);font-size:20px;margin-left:-24px;padding:20px;'></a>")) +
                "|LeaveCode|" + (val.LeaveDescription == null ? "" : val.LeaveDescription) + "|FromDate|" + val.FromDateDisplay + "|ToDate|" + val.ToDateDisplay + "|Hours|" + val.PlannedHours + "|DefaultWorkHours|" + val.DefaultWorkHours +
                "|Name|" + val.SubmittedbyFullName + "|Status|" + val.RequestStatus + "|Note|" + val.ApprovalString;
              tempAdd = tempAdd.add(1).day();
            } else {
              if (val2[dateKey].substring(0, 1) == "C" && val2[dateKey].substring(0, 1) != "H") {
                val2[dateKey] =
                  (val.RequestStatus == "H" ? "H<a style='background-color:#00c4ff;color:white;font-size: 28px;margin-left:-24px;padding: 7px;' href='javascript:void(0)' class='load'><i class='modus-icons'>car_front</i></a>" :
                    val.RequestStatus == "Approved" ? (val.PlannedHours >= val.DefaultWorkHours ? "A<a style='background-color:#5cb85c;color:white;font-size: 27px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>circle_check_outline</i></a>" : "A<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/approvedHalf.png'/></a>") :
                      val.RequestStatus == "Rejected" ? (val.PlannedHours >= val.DefaultWorkHours ? "R<a style='background-color:red;color:white;font-size: 26px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>cancel_circle</i></a>" : "R<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/rejectedHalf.png'/></a>") :
                        val.RequestStatus == "Pending" ? (val.PlannedHours >= val.DefaultWorkHours ? "P<a style='background-color:#ECC816;color:white;font-size: 29px;margin-left:-24px;padding: 8px;' href='javascript:void(0)' class='load'><i class='modus-icons'>help</i></a>" : "P<a href='javascript:void(0)' class='load'><img style='margin-bottom:10px;margin-left:-19px;' src='/dist/assets/Images/pendingHalf.png'/></a>") :
                          (tempAdd.getDay() != 0 && tempAdd.getDay() != 6 ? "C<a style='background-color:white;color:white;font-size:20px;margin-left:-24px;padding:20px;'></a>" : "C<a style='background-color:rgb(204, 204, 204);color:rgb(204, 204, 204);font-size:20px;margin-left:-24px;padding:20px;'></a>")) +
                  "|LeaveCode|" + (val.LeaveDescription == null ? "" : val.LeaveDescription) + "|FromDate|" + val.FromDateDisplay + "|ToDate|" + val.ToDateDisplay + "|Hours|" + val.PlannedHours + "|DefaultWorkHours|" + val.DefaultWorkHours +
                  "|Name|" + val.SubmittedbyFullName + "|Status|" + val.RequestStatus + "|Note|" + val.ApprovalString;
              }

              tempAdd = tempAdd.add(1).day();
            }
          }
        }
      });
    });
    var tempFoYr = this.formData.selectedMonth.getFullYear();
    var tempFoMth = this.formData.selectedMonth.getMonth();
    var tempToYr = this.formData.selectedMonth.getFullYear();
    var tempToMth = this.formData.selectedMonth.getMonth() + 1;
    if (tempToMth == 12) {
      tempToYr++;
      tempToMth = 0;
    }
    var tempAdd = new Date(tempFoYr, tempFoMth, 1);
    while (tempAdd <= new Date(tempToYr, tempToMth, 1)) {
      var month = tempAdd.getMonth() + 1;
      var date = tempAdd.getDate().toString().length == 1 ? "0" + tempAdd.getDate() : tempAdd.getDate();
      var year = tempAdd.getFullYear();
      this.webixDataList.forEach(val => {
        if (!val.hasOwnProperty((month + "/" + date + "/" + year))) {
          if (tempAdd.getDay() == 6 || tempAdd.getDay() == 0) {
            val[month + "/" + date + "/" + year] = "<a style='background-color:rgb(204, 204, 204);color:rgb(204, 204, 204);font-size:20px;margin-left:-16px;padding:20px;'></a>";
          }
        }
      });
      tempAdd = tempAdd.add(1).day();
    }
  }

  getNewDates(startDate: any, stopDate: number | Date) {
    var dateArray = new Array();
    dateArray.push({ id: "Employee", header: { text: "Employee", rotate: false, height: 60 }, width: 150, sort: "string" });
    var currentDate = startDate;
    while (currentDate < stopDate) {
      var month = currentDate.getMonth() + 1;
      var date = currentDate.getDate().toString().length == 1 ? "0" + currentDate.getDate() : currentDate.getDate();
      var year = currentDate.getFullYear();
      dateArray.push({ id: month + "/" + date + "/" + year, header: { text: ((this.portalSettings.CountryDateCode.ConfigValue == "US") ? (month + "/" + date) : (date + "/" + month)), rotate: true, css: "myClass" }, width: 30 });
      currentDate = currentDate.add(1).day();
    }
    return dateArray;
  }

  monthChange() {
    this.loadingStatus.emit(false);
    this.data = null;
    if (this.ui != null) {
			this.ui.destructor();
			this.ui = null;
		}
    var orderByColumn = [];
    orderByColumn.push("SubmittedbyFullName");
    if (this.formData.selectedMonth != null) {
      if (this.formData.selectedMonth.getDate() > 1) {
        this.formData.selectedMonth = new Date(this.formData.selectedMonth.getFullYear(), this.formData.selectedMonth.getMonth(), 1);
      }
    }
    var tempselectedDate = new Date(this.formData.selectedMonth.getTime());
    this.monthOn = true;
    this.newDateArray = [];
    this.newDateArray = this.getNewDates(new Date(tempselectedDate.setHours(0, 0, 0, 0)), tempselectedDate.add(1).month());
    this.monthData = [];
    if (this.formData.selectedMonth != null) {
      this.timeOffService.getRequestsByMonth(this.company, moment(this.formData.selectedMonth).format("YYYY-MM-DD"), this.userKeyID).then((response: any[]) => {
        this.webixUpdate(this.orderByPipe.transform(response, orderByColumn, "asc"));
        this.monthData = this.webixDataList;
        this.loadGrid();
      });
    }
  }

}